import "./style.css";
import { forwardRef, useImperativeHandle, useState } from "react";
import { requestGetState } from "./../../../api/api.ramadan";

const RamadanState = forwardRef((props, ref) => {
  const dialogId = "ramadan-state-dialog";
  const cardId = "ramadan-state-dialog-card";
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  function show() {
    const dialog = document.getElementById(dialogId);
    dialog.showModal();
    setTimeout(() => {
      const container = document.getElementById(cardId);
      container.classList.add("show");
      setLoading(true);
      requestGetState().then((response) => {
        const result = response.result;
        setList(result);
        setLoading(false);
      });
    }, 300);
  }

  function onKeyDown(e) {
    if (e.key === "Escape") {
      hide();
    }
  }

  function onClickBackdrop(e) {
    const dialog = document.getElementById(dialogId);
    if (e === dialog) {
      hide();
    }
  }

  function hide() {
    const container = document.getElementById(cardId);
    container.classList.remove("show");
    setTimeout(() => {
      const dialog = document.getElementById(dialogId);
      dialog.close();
    }, 300);
  }

  function onClickItem(item) {
    hide();
    setTimeout(() => {
      if (props.onSelect) {
        props.onSelect(item.id_state, item.state_name);
      }
    }, 300);
  }

  const Items = () => {
    return list.map((item, i) => {
      return (
        <div
          id={"ramadan-state" + i}
          key={i}
          className="ramadan-state-item"
          onClick={() => onClickItem(item)}
        >
          {item.state_name}
        </div>
      );
    });
  };

  const Loading = () => {
    return (
      <div className="ramadan-state-loading">
        <span>Memuat</span>
        <span>Sila tunggu...</span>
      </div>
    );
  };

  useImperativeHandle(ref, () => {
    return { show };
  });

  return (
    <dialog
      id={dialogId}
      className="ramadan-state-dialog"
      onKeyDown={(e) => onKeyDown(e)}
      onClick={(e) => onClickBackdrop(e.target)}
    >
      <div id={cardId} className="ramadan-state-content">
        {loading ? <Loading /> : <Items />}
      </div>
    </dialog>
  );
});

export default RamadanState;
